import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { MarketingFund } from '../types';

export const default_event = {
  id: 0,
  event_name: '',
  event_type: '',
  status: {
    id: 0,
    name: '',
    slug: '',
  },
  date_start: null,
  date_end: null,
  total_costs: null,
  pre_compensation: null,
  list_advertised_products: '',
  size_audience_reached: null,
  size_audience_reached_name: '',
  geography_audience_reached: '',
  url: '',
  promotion_description: '',
  other_trademarks: '',
  expected_effect: '',
  location: '',
  target_audience: '',
  expected_sales_volume: null,
  mf_event_participants_list: null,
  mf_event_pre_program: null,
  mf_event_pre_expenses: null,
  mf_event_layout_design: null,
  request_marketing_fund: {
    id: 0,
    request_name: '',
    request_status: {
      id: 0,
      name: '',
      slug: '',
    },
  },
  history: [],
};

export const default_report_form = {
  final_url: null,
  final_list_advertised_products: null,
  title_promo: null,
  text_promo: null,
  tags_list: null,
  final_location: null,
  final_name_event: null,
  final_description_event: null,
  send_to_atol: false,
};

export const default_files_from_server = {
  user_list_file: [],
  pre_programm_file: [],
  pre_expenses_file: [],
  event_layout_design_file: [],
};

export const default_size_audience_reached = {
  id: 0,
  name: '',
  slug: '',
};

export const default_report_files = {
  mf_event_final_agreement: [],
  mf_event_confirming_documents: [],
  mf_event_final_program: [],
  mf_event_final_expenses: [],
  mf_event_final_design: [],
  mf_event_final_banner_mockup: [],
  mf_event_final_participants_list: [],
};

export const default_event_report = {
  mf_event_final_agreement: [],
  mf_event_confirming_documents: [],
  mf_event_final_program: [],
  mf_event_final_expenses: [],
  mf_event_final_design: [],
  mf_event_final_banner_mockup: [],
  mf_event_final_participants_list: [],
  final_url: '',
  final_list_advertised_products: '',
  title_promo: '',
  text_promo: '',
  tags_list: '',
  final_location: '',
  final_name_event: '',
  final_description_event: '',
};

export const default_aplication = {
  id: 0,
  date: '',
  name: '',
  status: {
    id: 0,
    name: '',
    slug: '',
  },
  available_send_to_atol: false,
};

export const default_application_filters: MarketingFund.AplicationsFilters = {
  status: [],
  date: [],
  name: '',
  only_has_unread_changes: false,
};

export const default_event_filters: MarketingFund.EventsFilters = {
  status: [],
  type: [],
  name: '',
  only_has_unread_changes: false,
};

export const default_current_event_type = {
  id: 0,
  name: '',
  slug: '',
};
export default class MarketingFundState extends BaseState {
  /** Модели заявок и мероприятий с первой страницы МФ */
  aplications: MarketingFund.Aplication[] = [];
  events: MarketingFund.Event[] = [];

  marketing_fund_limit = 0;
  size_audience_reached_list: MarketingFund.SizeAudience[] = [];

  events_for_aplication: MarketingFund.Event[] = [];
  history_for_aplication: MarketingFund.History[] = [];
  aplication: MarketingFund.AplicationDetail = { ...default_aplication };

  aplications_loading = false;
  events_loading = false;

  /** Модель мероприятия приходящая с бэка */
  current_event: MarketingFund.EventForm = { ...default_event };

  /** Модель мероприятия для отправки */
  new_event: MarketingFund.EventForm = { ...default_event };

  current_aplication: MarketingFund.Aplication = {} as MarketingFund.Aplication;
  current_event_type: MarketingFund.CurrentEventType = { ...default_current_event_type };

  current_size_audience_reached: MarketingFund.SizeAudience = { ...default_size_audience_reached };

  size_key = 0;

  /** файлы мероприятия */
  user_list_file: File | null = null;
  user_list_file_deleted = false;

  pre_programm_file: File | null = null;
  pre_program_file_deleted = false;

  pre_expenses_file: File | null = null;
  pre_expenses_file_deleted = false;

  event_layout_design_file: File | null = null;
  event_layout_design_file_deleted = false;

  event_files_from_server: MarketingFund.FilesFromServer = { ...default_files_from_server }

  event_types_list: MarketingFund.Type[] = [];

  current_application_id = 0;
  current_event_id = 0;

  event_created = false;
  event_changed = false;

  template_modal_visible = false;
  sent_to_atol_available_visible_model = false;
  application_created_visible_model = false;
  not_created_visible_model = false;
  already_created_visible_model = false;
  send_event_to_atol_modal = false;

  created_application_message = ''

  /** Отчеты мероприятия */
  new_report_form: MarketingFund.ReportForm = { ...default_report_form };
  // current_report_form: MarketingFund.ReportForm = { ...default_report_form };

  current_report_files: MarketingFund.ReportFiles = { ...default_report_files }

  current_event_reports: MarketingFund.EventReport = { ...default_event_report };

  mf_event_final_agreement_file: File | null = null;
  mf_event_confirming_documents: File[] = [];
  mf_event_final_banner_mockup: File | null = null;
  mf_event_final_program: File[] = [];
  mf_event_final_participants_list: File | null = null;
  mf_event_final_expenses: File[] = [];
  mf_event_final_design: File | null = null;

  /** Фильтры */
  aplication_filters: MarketingFund.AplicationsFilters = { ...default_application_filters };

  events_filters: MarketingFund.EventsFilters = { ...default_event_filters };

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };
}
